/* eslint-disable */
import { StackNavigator } from "react-navigation"
import LoginScreen from "../Containers/LoginScreen"
import SignUpScreen from "../Containers/SignUpScreen"
import AuthenticationScreen from "../Containers/AuthenticationScreen"
import WebViewScreen from "../Containers/WebViewScreen"


import styles from "./Styles/NavigationStyles"
const MainStack = StackNavigator(
  {
    AuthenticationScreen: { screen: AuthenticationScreen },
    LoginScreen: { screen: LoginScreen },
    SignUpScreen: { screen: SignUpScreen },
  },
  {
     
    initialRouteName: "AuthenticationScreen", // LoginScreen, LaunchScreen
    navigationOptions: {
      headerStyle: styles.header
    }
    /* Same configuration as before */
  }
);

const RootStack = StackNavigator(
  {
    home: {
      screen: MainStack,
    },
    WebViewScreen: {
      screen: WebViewScreen,
    },
  },
  {
    mode: 'modal',
    headerMode: 'none',
  }
);




export default RootStack
